<template>
  <div class="box">
      <!-- imports -->
      <div>
        <div class="box-title flex between middle">
          <div class="flex between middle">
            Importações - 
            <div style="margin-left: 16px">Precisa importar manualmente vendas? <router-link :to="{ name: 'SubscriptionRedirect' }">Faça Upgrade</router-link></div>
          </div>
          <div class="">
            <div class="button primary" :class="{'disable': alertLimit }" @click="openModalCreate()">
              NOVA IMPORTAÇÃO
            </div>
          </div>
        </div>
        <div class="box-content">
          <div v-if="!loading" class="flex w100">
              <ul class="list-imports">
                <li v-for="(imp, index) in imports" :key="index">
                  <div class="flex middle">
                    <div class="flex-2 flex column">
                      <div><b>Nome do Arquivo</b></div>
                      <div class="margin-top-s">{{ imp.file_name }}</div>
                    </div>
                    <div class="flex-1 flex column">
                      <div><b>Data de Criação</b></div>
                      <div class="margin-top-s">{{ '2024-09-01 00:00:00' | data }}</div>
                    </div>
                    <div class="flex-1 flex column">
                      <div><b>Status</b></div>
                      <div class="margin-top-s">{{ _decodeStatus(imp.status) }}</div>
                    </div>
                    <div class="flex-1 flex end">
                      <div class="button secondary" @click="showModalDelete=true;selectedImport=imp.id">DELETAR</div>
                    </div>
                  </div>
                </li>
              </ul>
          </div>
          <div v-if="loading">
            <content-loading>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
            </content-loading>
          </div>
          <div v-if="isEmpty">
            <p>Não encontramos nenhuma importação para esta conta.</p>
          </div>
        </div>
      </div>

    <!-- modal confirm delete -->
    <modal-confirm
      :show="showModalDelete"
      description="Você tem certeza que deseja deletar a importação?"
      @cancel="
        showModalDelete = false;
        selectedImport = null;
      "
      @accept="deleteImport(selectedImport)"
    ></modal-confirm>

    <!-- modal new user / update -->
    <modal
      :title="modalTitle"
      :show="showModalCreateOrUpdate"
      @close="cleanProjectInfo()"
    >
      <div class="content flex " slot="content">
        <div class="flex column w100">
          <div class="flex w100 column">
            <p>Modelo de arquivo para VENDAS: <a :href="urlModel" target="_blank">Clique Aqui</a> para baixar </p>
            <form class="margin-top-l w100">
              <div
                class="upload-area w100"
                @click="!loaderFile && $refs.fileInput.click()"
              >
                <label
                  v-if="!loaderFile && !successFile"
                  class="placeholder"
                  style="cursor:pointer"
                >
                  <i class="fas fa-cloud-upload-alt"></i>
                  <span>Fazer upload do ARQUIVO</span>
                </label>
                <label
                  v-if="successFile"
                  class="placeholder"
                  style="cursor:pointer"
                >
                  <i class="fas fa-cloud-upload-alt"></i>
                  <p>
                    Seu arquivo já está em nossos servidores e
                    está sendo processado...
                  </p>
                </label>
                <input
                  ref="fileInput"
                  type="file"
                  @change="uploadFile"
                  style="display: none"
                />
                <div v-if="loaderFile">
                  <p>Enviando arquivo...</p>
                </div>
              </div>
            </form>
          </div>
          <div class="flex w100 center margin-top-l">
            <div class="button primary" @click="saveOrUpdate()">Criar Importação</div>
          </div>
        </div>
      </div>
    </modal>
    </div>
</template>

<script>

import Modal from "@/components/modal/Modal";
import ModalConfirm from "@/components/modal/ModalConfirm";

import { mapState } from "vuex";

import {
  getImports,
  createImport,
  deleteImport,
} from "@/services/imports";

import { Upload } from "@/services/upload";


export default {
  name: "config-imports",
  components: {
    Modal,
    ModalConfirm,
  },
  data() {
    return {
      loading: false,
      loaderFile: false,
      selectedImport: null,
      successFile: null,
      tmpFileName: null,
      file_name: null,
      showModalCreateOrUpdate: false,
      showModalDelete: false,
      fileType: [
        'SALES',
      ],
      imports: [],
    };
  },
  mounted() {
    this.getImports()
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    urlModel() {
      return `${window.location.origin}/admin/static/sample/modelo-vendas.csv`
    },
    modalTitle() {
      return 'Nova Importação'
    },
    alertLimit() {
      if (!this.checkResource('config-imports')) {
        return true
      }

      return false
    },
    isEmpty() {
      return !this.loading && this.imports && this.imports.length === 0
    }
  },
  methods: {
    _decodeStatus(status) {
      let _map_status = {
        'success': 'SUCESSO',
        'error': 'FALHA',
      }
      return _map_status[status] || status;
    },
    openModalCreate() {
      if(this.alertLimit) {
        this.$toast.error({
          title:'Erro',
          message:'Você já está usando o limite de importações do seu plano! Faça upgrade para criar mais!'
        })

        return

      }
      this.showModalCreateOrUpdate = true
    },
    cleanProjectInfo() {
      this.tmpFileName = null
      this.file_name = null
      this.showModalCreateOrUpdate = false
    },
    saveOrUpdate() {
      this.showModalCreateOrUpdate = false
      this.createImport(this.newProject)
    },
    checkResource(name) {
      return this.account && this.account.resources.includes(name);
    },
    getImports() {
      this.loading = true
      getImports()
        .then((result) => {
          this.imports = result
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu um problema ao buscar dados'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    createImport() {
      if (!this.tmpFileName) {
        this.$toast.error({
          title:'Erro',
          message:'Preencha um nome para criar um projeto'
        })
        
        return
      }

      let params = {
        file_name: this.file_name,
        tmpFileName: this.tmpFileName,
        type: 'csv',

      }
      createImport(params)
        .then((result) => {
          this.$toast.success({
            title:'Sucesso',
            message:'Importação criada com sucesso'
          })
          this.imports.push(result)
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title:'Erro',
            message:'Erro ao criar importação'
          })
        })
    },
    deleteImport() {
      deleteImport(this.selectedImport)
      .then(() => {
        this.imports = this.imports.filter(p => p.id !== this.selectedImport)
        this.$toast.success({
          title:'Sucesso',
          message:'Importação removida'
        })
      })
      .catch((error) => {
        if (error && error.message === "request-canceled") {
            return;
          }
        this.$toast.error({
          title:'Erro',
          message:'Ocorreu um problema ao deletar importação'
        })
      })
      .finally(() => {
        this.selectedImport = null
        this.showModalDelete = false
      })
    },
    uploadFile() {
      this.file = this.$refs.fileInput.files[0];
      const types = [
        "application/csv",
        "text/csv",
        ".csv",
        "text/comma-separated-values",
      ];

      // TODO: Validar se esse dois metodos não vão apresentar problemas
      if (!types.includes(this.file.type) && !this.file.name.includes(".csv")) {
        return this.$toast.error({
          title: "Erro",
          message: "O formato do arquivo deve ser csv",
        });
      }

      this.loaderFile = true;
      Upload(this.content, this.file, "csv")
        .then((response) => {
          this.successFile = true;
          this.file_name = this.file.name;

          this.tmpFileName = response.file_name;

          this.$toast.success({
            title: "Sucesso",
            message: "Upload realizado com sucesso",
          });
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }

          this.$toast.error({
            title: "Erro",
            message: "Falha ao fazer upload.",
          });
        })
        .finally(() => {
          this.loaderFile = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.account {
  padding: 16px;
  border-right: 1px solid #c2c2c235;
}

.subscription {
  padding: 16px;
  ul {
    padding-left: 15px;
    li {
      // list-style-type: none;
      padding-top: 8px;
      padding-bottom: 8px;
      margin-bottom: 8px;
    }
  }
}

.list-imports {
  width: 100%;
  li {
    list-style-type: none;
    padding-top: 8px;
    padding-bottom: 8px;
    margin-bottom: 8px;
    border-bottom: 1px solid #c2c2c258;
  }
}

.actions {
  > div {
    margin-left: 4px;
  }
}

.disable {
  background: #c2c2c2 !important;
}


.upload-area {
  cursor: pointer;
}
</style>
